import type { IIntegration } from '@/interfaces/agency/integration';
import axios from '@axios';

export default {
  async getIntegrations() {
    return await axios.get<IIntegration[]>('/integration');
  }
};
